export const sortToObject = ({ sortBy, sortDirection }) => {
	return { [sortBy]: sortDirection === 'desc' ? -1 : 1 }
}
